var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [
      _c("b", [_vm._v(_vm._s(_vm._.get(_vm.activity, "actorUser.name")))]),
      _vm._v(" " + _vm._s(_vm.$t("auto.removedFromWhiteList")) + " "),
      _c("b", [_vm._v(_vm._s(_vm._.get(_vm.activity, "payload.ipAddress")))]),
      _vm._v(".\n    "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }